import axios from 'axios';
import _ from 'lodash';

import BaseModel from './BaseModel';
import UserModel from './UserModel';
import ParkinglocationModel from './ParkinglocationModel.js';

const BASE = BaseModel.getApiBasePath() + '/api/v1/mpa/parkinglocations';

export default new class MpaParkinglocationModel {

  get(id) {
    return new Promise((resolve, reject) => {
      this.getAll()
        .then((data) => {
          resolve(_.find(data, {id: id}));
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  getAll(force = false) {    
    return new Promise((resolve, reject) => {      
      axios.get(BASE, {
        params: {
          access_token: UserModel.getAccessToken()
        }
      })
      .then((response) => {        
        ParkinglocationModel.getAll()
        .then((pl) => {
          let data = [];
          response.data.map(async (child, idx) => { 
            let location = _.find(pl, {id: child.ParkingLocationID});            
            location 
              ? data.push(Object.assign({}, child, {ParkingLocationName: location.Code + ' - ' + location.Name}))
              : data.push(Object.assign({}, child, {ParkingLocationName: 'Neznámá lokalita'}));        
          });
          resolve(data);          
        });        
      })
      .catch((error) => {
        reject(error);
      });      
    });    
  }

  create(data) {
    return new Promise((resolve, reject) => {
      axios.post(BASE, data, {
        params: {
          access_token: UserModel.getAccessToken()
        }
      })
      .then((response) => {        
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
    });
  }

  remove(id) {
    return new Promise((resolve, reject) => {
      axios.delete(BASE + '/' + id, {
        params: {
          access_token: UserModel.getAccessToken()
        }
      })
      .then((response) => {        
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
    });
  }

}


// WEBPACK FOOTER //
// ./src/components/MpaParkinglocationModel.js